import { render, staticRenderFns } from "./cross.vue?vue&type=template&id=6995771d&"
import script from "./cross.vue?vue&type=script&lang=ts&"
export * from "./cross.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports